import Link from '../../components/Link';

import getWebAppRouteKey from '../getWebAppRouteKey';
import getPathName from '../getPathName';

export interface Options {
  currentPathName?: string;
  getCanUseClientRouting?: (path: string) => boolean;
  args?: Record<string, string>;
  query?: Record<string, string>;
  hash?: string;
}

function getCanUseClientRouting(currentPathName: string, targetPath: string) {
  const isCurrentUrlWebApp =
    Boolean(getWebAppRouteKey(currentPathName)) && Boolean(document.getElementById('webapp'));
  const isTargetPathWebApp = Boolean(getWebAppRouteKey(targetPath));
  return isCurrentUrlWebApp && isTargetPathWebApp; // small hack since courses page are both in webapp and not in webapp for no
}

function getClassicLinkProps(url: string) {
  return { component: 'a', href: url, 'data-client-router': 'none' };
}

export default function getButtonLinkProps(
  path: string,
  {
    currentPathName = typeof document !== 'undefined' ? document.location.pathname : '',
    args = {},
    query = {},
    hash,
  }: Options = {}
) {
  const isUsPath = path.startsWith('/us/'); // FIXME: remove this when we use /us for all pages

  if (path.startsWith('../')) {
    return {
      component: Link,
      to: path,
      role: 'link',
    };
  }

  if (!path.startsWith('/') || isUsPath) {
    return getClassicLinkProps(path);
  }

  const canUseClientRouting = getCanUseClientRouting(currentPathName, path);

  let url = getPathName(path, args, !canUseClientRouting);

  // we should remove /:lang from the url if we use client side router
  if (canUseClientRouting && url.match(/^\/[a-z]{2}\//)) {
    url = url.substring(3);
  }

  let hashString = '';

  if (hash) {
    hashString = `#${hash}`;
  } else if (path.includes('#')) {
    const [, hashFromPath] = path.split('#');
    hashString = `#${hashFromPath}`;
  }

  let searchParams = '';

  if (Object.keys(query).length > 0) {
    searchParams = new URLSearchParams(query).toString();
  } else if (path.includes('?')) {
    searchParams = path.match(/\?([^#]+)/)?.[1] ?? '';
  }

  const finalUrl = url + (searchParams ? `?${searchParams}` : '') + hashString;

  return canUseClientRouting
    ? {
        component: Link,
        to: path.match(/(\?|#)/)
          ? finalUrl
          : {
              pathname: url,
              search: searchParams,
              hash,
            },
        role: 'link',
        'data-client-router': 'react-router',
      }
    : getClassicLinkProps(finalUrl);
}
